import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M22 21H2V11C2 9.89543 2.89543 9 4 9H8V4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V7H20C21.1046 7 22 7.89543 22 9V21ZM16 9V19H20V9H16ZM10 4V19H14V4H10ZM4 11V19H8V11H4Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "BarChartAlt"
);
